import { useState, useEffect, useRef, Fragment, memo, useContext } from "react";
import style from "./../index.module.scss";
import styleUi from "./CreateNewPot.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Checkbox from '@mui/material/Checkbox';
import EXIF from 'exif-js';
import LinkIcon from '@mui/icons-material/Link';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import * as YStyle from "../../Styleds";
import apiManager from '../../ApiManager';
import { GameContext } from "../../GameContext";
const CreateNewPot = ({setModalType, arg, addModalType }) => {
    const { updatePocketlist } = useContext(GameContext);
    const [inProp, setInProp] = useState(false);
    const [data, set_data] = useState({ name: "", position: arg.selectCustomPosition, photos: [], links: [], pocketListObj: "" });
    useEffect(() => {

        console.log("CreateNewPot");
        if (arg.createNewPotData)
            set_data(arg.createNewPotData);
        setInProp(true);
    }, [])

    const handleFileChange = (e, ind) => {
        const files = Array.from(e.target.files).slice(0, 3);
        const promises = files.map(file => getGpsData(file));

        Promise.all(promises).then(results => {
            console.log(ind, results);
            if (ind > -1) {
                set_data(props => {
                    let _props = { ...props };
                    _props.photos[ind] = results[0];
                    return _props
                });
            }
            else {
                set_data(props => {
                    return { ...props, photos: results }
                });
            }
        });
    };
    function submit() {
        console.log(data);
        var formdata = new FormData();
        formdata.append("rewilding_apply_official", "false");
        formdata.append("rewilding_lat", data.position.lat());
        formdata.append("rewilding_lng", data.position.lng());
        formdata.append("rewilding_name", data.name);
        if(data.photos[0]?.file)
        formdata.append("rewilding_photo[]", data.photos[0]?.file);
        formdata.append("rewilding_pocket_list", data.pocketListObj.pocket_lists_id);
        data.links.forEach(v=>{
            formdata.append("rewilding_reference_information", v.url);
        })
        for (var pair of formdata.entries()) {
            console.log(pair[0]+ ': ' + pair[1]);
        }
        const fnArr = {}
        addModalType({
            cls: "Loading", arg: { fnArr: fnArr }
        })
        apiManager.fetchPostForm("rewilding", formdata).then(res => {
            fnArr.doCloseFn();
            if(res.message)
            {
                alert(res.message);
            }
            else
            {
                arg.cb(res);
                updatePocketlist("updateList",data.pocketListObj.pocket_lists_id);
                setInProp(false);
            }
        })
    }
    const getGpsData = (file) => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = () => {
                EXIF.getData(file, function () {
                    const lat = EXIF.getTag(this, 'GPSLatitude');
                    const lon = EXIF.getTag(this, 'GPSLongitude');
                    const latRef = EXIF.getTag(this, 'GPSLatitudeRef');
                    const lonRef = EXIF.getTag(this, 'GPSLongitudeRef');
                    const imageUrl = URL.createObjectURL(file);
                    if (lat && lon && latRef && lonRef) {
                        const latitude = convertDMSToDD(lat, latRef);
                        const longitude = convertDMSToDD(lon, lonRef);
                        resolve({ file: file, imageUrl, latitude, longitude });
                    } else {
                        resolve({ file: file, imageUrl });
                    }
                });
            };
            reader.readAsArrayBuffer(file);
        });
    };
    const convertDMSToDD = (dms, ref) => {
        const degrees = dms[0] + dms[1] / 60 + dms[2] / 3600;
        return ref === 'S' || ref === 'W' ? -degrees : degrees;
    };

    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "CreateNewPot"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app}>
                                <YStyle.Span size={20}>輸入地點資訊</YStyle.Span>
                                <div className={styleUi.boxName}>
                                    <YStyle.Span size={18} style={{ marginBottom: ".4rem" }}>名稱</YStyle.Span>
                                    <div>
                                        <input type='text' value={data.name} placeholder={"地點名稱"}
                                            onChange={e => {
                                                set_data(props => ({ ...props, name: e.target.value }));
                                            }} />
                                    </div>
                                </div>
                                <div className={styleUi.boxPosition}>
                                    <YStyle.Span size={18} style={{ marginBottom: ".4rem" }}>座標</YStyle.Span>
                                    <div>
                                        <div>
                                            <span>{arg.selectCustomPosition.lat().toFixed(4)},{arg.selectCustomPosition.lng().toFixed(4)}</span>
                                        </div>
                                        <YStyle.BTN3 normalBg="#EDECE8" style={{ borderColor: "#00000015", borderRadius: "10px", padding: ".8rem 2rem" }} onClick={e => {
                                            arg.onEdit(data)
                                            setInProp(false);
                                        }}>
                                            <img src="./assets/ui/position.png" />
                                            <YStyle.Span size={15} color="black">定位座標</YStyle.Span>
                                        </YStyle.BTN3>

                                    </div>
                                </div>
                                <div className={styleUi.boxPhoto}>
                                    <YStyle.Span size={18} style={{ marginBottom: ".4rem" }}>照片</YStyle.Span>
                                    <div>
                                        {data.photos.map((v, k) => {
                                            return <label key={k} className={styleUi.photoBox}>
                                                <img src={v.imageUrl} />
                                                <div className={styleUi.delBtn}>
                                                    <img src="./assets/ui/x.png" onClick={e => {
                                                        set_data(prev => ({ ...prev, photos: [] }))
                                                    }} />
                                                </div>
                                            </label>
                                        })}
                                        {data.photos.length < 1 &&
                                            <label className={styleUi.selPhotoBtn}>
                                                <AddCircleOutlineIcon />
                                                <span>新增</span>
                                                <input type="file" accept="image/*" multiple={false} onChange={e => { handleFileChange(e, -1) }} />
                                            </label>
                                        }
                                    </div>
                                </div>
                                <div className={styleUi.boxLinks}>
                                    <YStyle.Span size={18}>參考資訊</YStyle.Span>
                                    <YStyle.Label style={{ padding: ".5rem", background: "#EDECE8", border: "solid 2px #00000015", cursor: "pointer" }} onClick={e => {
                                        addModalType({
                                            cls: "AddLink", arg: {
                                                type: "rewilding",
                                                cb: linkObj => {
                                                    console.log("linkObj", linkObj)
                                                    set_data(props => ({ ...props, links: [...props.links, linkObj] }));
                                                }
                                            }
                                        })
                                    }}>
                                        <img src="./assets/ui/addLink.png" />
                                        <YStyle.Span size={15}>新增連結</YStyle.Span>
                                    </YStyle.Label>
                                    {
                                        data.links.map((v, k) => {
                                            return <div>
                                                <YStyle.Label style={{ padding: ".6rem ", justifyContent: "space-between" }}>
                                                    <LinkIcon />
                                                    <YStyle.Span style={{flexGrow:1}}>{v.title}</YStyle.Span>
                                                    <CloseIcon onClick={e => {
                                                        set_data(props => {
                                                            const _props = { ...props }
                                                            _props.links = _props.links.filter(linkObj => linkObj !== v);
                                                            return _props;
                                                        });
                                                    }} />
                                                </YStyle.Label>
                                            </div>
                                        })
                                    }
                                </div>
                                <div className={styleUi.boxSelFolder}>
                                    <YStyle.Span size={18}>儲存至清單</YStyle.Span>
                                    <div onClick={e => {
                                        addModalType({
                                            cls: "SavePot", arg: {
                                                cb: (pocketListObj) => {
                                                    set_data(props => {
                                                        return { ...props, pocketListObj: pocketListObj }
                                                    });
                                                }
                                            }
                                        })
                                    }}>
                                        <input type='text' value={data.pocketListObj?.pocket_lists_name} placeholder={"請選擇"}
                                            readOnly={true} />
                                        <IconButton onClick={e => {

                                        }}>
                                            <KeyboardArrowDownIcon />
                                        </IconButton>
                                    </div>
                                </div>

                                <span className={styleUi.tip}>為必填</span>
                                <button disabled={data.name === "" || data.position === null} className={allStyle.btnBlack1} style={{ width: "100%" }} onClick={e => {
                                    submit();
                                }}>
                                    建立野放點
                                </button>
                                <IconButton className={styleUi.close} onClick={e => {
                                    setInProp(false)
                                }}>
                                    <CloseIcon />
                                </IconButton>
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition >
        </div >
    );
}

export default memo(CreateNewPot);